import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export default function TrustBalancePlaceholder() {
  return (
    <div className="card-bg p-3">
      <div className="row">
        <div className="col-12">
          <Skeleton width="40%" height="20px" className="mb-2" borderRadius="6px" />
          <Skeleton width="70%" height="40px" borderRadius="8px" />
        </div>
      </div>
    </div>
  );
}
